import {ordoroFetch} from './ordoroFetch.js'
import {stringify} from './querystring.js'

export function formatAbodeURL(url, query) {
  return `${window.ORDORO_BOOTSTRAP.env.PAPPY_ENV_ABODE_URL}${url}${query ? `?${stringify(query)}` : ''}`
}

export function abodeFetch(method, url, data, options) {
  return ordoroFetch(
    method,
    formatAbodeURL(url, method === 'get' && data),
    data,
    options,
  )
}

export async function abodeRenderPOST(data) {
  const {response: pdfRes} = await abodeFetch('post', '/render', data, {
    handleResponse: false,
  })

  const blob = await pdfRes.blob()

  const file = new File(
    [blob],
    pdfRes.ok ? data.file_name || 'document.pdf' : 'error.json',
    {
      type: pdfRes.headers.get('Content-Type'),
    },
  )

  return file
}

export default {
  head(url, data, options) {
    return abodeFetch('head', url, data, options)
  },
  get(url, data, options) {
    return abodeFetch('get', url, data, options)
  },
  put(url, data, options) {
    return abodeFetch('put', url, data, options)
  },
  post(url, data, options) {
    return abodeFetch('post', url, data, options)
  },
  patch(url, data, options) {
    return abodeFetch('patch', url, data, options)
  },
  delete(url, data, options) {
    return abodeFetch('delete', url, data, options)
  },
}
